import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'
import { generateOptionsFromStringArray } from '../utility/utility'

const typeOptions = generateOptionsFromStringArray(['Expense', 'Procurement'])

const namePlaceholder = props => <AutoCompleteDropdown options={typeOptions} {...props} />

export default namePlaceholder
